import { z } from 'zod';
export var AppearanceType;
(function (AppearanceType) {
    AppearanceType["Toggle"] = "TOGGLE";
    AppearanceType["Dropdown"] = "DROPDOWN";
})(AppearanceType || (AppearanceType = {}));
export const AppearanceSchema = z.object({
    type: z.nativeEnum(AppearanceType),
    helpText: z.string()
});
//# sourceMappingURL=appearance.js.map